import type { FormEvent } from 'react'
import type { EmpresaGrupo } from '../types'

interface SearchFormProps {
  q: string
  onde: string
  empresaFiltro: string
  total: number
  empresasFiltro: EmpresaGrupo[]
  onQChange: (v: string) => void
  onOndeChange: (v: string) => void
  onEmpresaChange: (slug: string) => void
  onSubmit: () => void
  findEmpresaNome: (slug: string) => string | null
}

export function SearchForm({
  q,
  onde,
  empresaFiltro,
  total,
  empresasFiltro,
  onQChange,
  onOndeChange,
  onEmpresaChange,
  onSubmit,
  findEmpresaNome,
}: SearchFormProps) {
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    onSubmit()
  }

  const empNome = empresaFiltro ? findEmpresaNome(empresaFiltro) : null
  const where = empNome ? ` em ${empNome}` : ' no Grupo HI'
  const countText =
    total === 1 ? `1 vaga aberta${where}` : `${total} vagas abertas${where}`

  return (
    <form className="cr-card cr-search-card" role="search" onSubmit={handleSubmit}>
      <div className="cr-search-head">
        <h2>Encontre sua próxima oportunidade</h2>
        <p className="cr-muted">Busque por cargo, palavra-chave, localização ou empresa do grupo.</p>
      </div>
      <div className="cr-search">
        <div className="cr-field">
          <label htmlFor="cr-q">O quê</label>
          <input
            id="cr-q"
            name="q"
            type="search"
            placeholder="cargo ou palavra-chave"
            autoComplete="off"
            value={q}
            onChange={(e) => onQChange(e.target.value)}
          />
        </div>
        <div className="cr-field">
          <label htmlFor="cr-onde">Onde</label>
          <input
            id="cr-onde"
            name="onde"
            type="search"
            placeholder="cidade, estado ou região"
            autoComplete="off"
            value={onde}
            onChange={(e) => onOndeChange(e.target.value)}
          />
        </div>
        <div className="cr-field cr-field-empresa">
          <label htmlFor="cr-empresa">Empresa</label>
          <select
            id="cr-empresa"
            name="empresa"
            aria-label="Filtrar por empresa"
            value={empresaFiltro}
            onChange={(e) => onEmpresaChange(e.target.value)}
          >
            <option value="">Todas as empresas</option>
            {empresasFiltro.map((e) => (
              <option key={e.slug} value={e.slug}>
                {e.nome_curto || e.nome}
              </option>
            ))}
          </select>
        </div>
        <button type="submit" className="cr-btn cr-btn-primary">
          Buscar
        </button>
      </div>
      <div className="cr-empresa-filter-chips" role="group" aria-label="Filtro rápido por empresa">
        <button
          type="button"
          className={`cr-filter-chip${!empresaFiltro ? ' on' : ''}`}
          style={{ ['--chip-cor' as string]: '#000070' }}
          onClick={() => onEmpresaChange('')}
        >
          <span className="cr-filter-chip-dot" aria-hidden="true" />
          Todas
        </button>
        {empresasFiltro.map((e) => (
          <button
            key={e.slug}
            type="button"
            className={`cr-filter-chip${empresaFiltro === e.slug ? ' on' : ''}`}
            style={{ ['--chip-cor' as string]: e.cor_secundaria || e.cor_primaria }}
            onClick={() => onEmpresaChange(e.slug)}
          >
            <span className="cr-filter-chip-dot" aria-hidden="true" />
            {e.nome_curto || e.nome}
          </button>
        ))}
      </div>
      <p className="cr-count">{countText}</p>
    </form>
  )
}
